export default {
  "audio_video": "./lottie/audio_video.json",
  "calling": "./lottie/calling.json",
  "alert_32px_loop": "./lottie/cisco-ai-assistant/alert_32px_loop.json",
  "hello_32px": "./lottie/cisco-ai-assistant/hello_32px.json",
  "processing_32px_end": "./lottie/cisco-ai-assistant/processing_32px_end.json",
  "processing_32px_loop": "./lottie/cisco-ai-assistant/processing_32px_loop.json",
  "processing_32px_start": "./lottie/cisco-ai-assistant/processing_32px_start.json",
  "responding_32px_end": "./lottie/cisco-ai-assistant/responding_32px_end.json",
  "responding_32px_loop": "./lottie/cisco-ai-assistant/responding_32px_loop.json",
  "responding_32px_start": "./lottie/cisco-ai-assistant/responding_32px_start.json",
  "contacts": "./lottie/contacts.json",
  "discoverability_badge": "./lottie/discoverability_badge.json",
  "heart_opacity_test": "./lottie/heart_opacity_test.json",
  "meeting": "./lottie/meeting.json",
  "personal_insight": "./lottie/personal_insight.json",
  "celebrate": "./lottie/reactions/celebrate.json",
  "clap_dark": "./lottie/reactions/clap_dark.json",
  "clap_light": "./lottie/reactions/clap_light.json",
  "clap_medium_dark": "./lottie/reactions/clap_medium_dark.json",
  "clap_medium_light": "./lottie/reactions/clap_medium_light.json",
  "clap_medium": "./lottie/reactions/clap_medium.json",
  "clap_yellow": "./lottie/reactions/clap_yellow.json",
  "fire": "./lottie/reactions/fire.json",
  "haha": "./lottie/reactions/haha.json",
  "heart": "./lottie/reactions/heart.json",
  "on_video_celebrate": "./lottie/reactions/on_video/on_video_celebrate.json",
  "on_video_clap_dark": "./lottie/reactions/on_video/on_video_clap_dark.json",
  "on_video_clap_light": "./lottie/reactions/on_video/on_video_clap_light.json",
  "on_video_clap_medium_dark": "./lottie/reactions/on_video/on_video_clap_medium_dark.json",
  "on_video_clap_medium_light": "./lottie/reactions/on_video/on_video_clap_medium_light.json",
  "on_video_clap_medium": "./lottie/reactions/on_video/on_video_clap_medium.json",
  "on_video_clap_yellow": "./lottie/reactions/on_video/on_video_clap_yellow.json",
  "on_video_fire": "./lottie/reactions/on_video/on_video_fire.json",
  "on_video_haha": "./lottie/reactions/on_video/on_video_haha.json",
  "on_video_heart": "./lottie/reactions/on_video/on_video_heart.json",
  "on_video_prayer_dark": "./lottie/reactions/on_video/on_video_prayer_dark.json",
  "on_video_prayer_light": "./lottie/reactions/on_video/on_video_prayer_light.json",
  "on_video_prayer_medium_dark": "./lottie/reactions/on_video/on_video_prayer_medium_dark.json",
  "on_video_prayer_medium_light": "./lottie/reactions/on_video/on_video_prayer_medium_light.json",
  "on_video_prayer_medium": "./lottie/reactions/on_video/on_video_prayer_medium.json",
  "on_video_prayer_yellow": "./lottie/reactions/on_video/on_video_prayer_yellow.json",
  "on_video_raise_hand_dark": "./lottie/reactions/on_video/on_video_raise_hand_dark.json",
  "on_video_raise_hand_light": "./lottie/reactions/on_video/on_video_raise_hand_light.json",
  "on_video_raise_hand_medium_dark": "./lottie/reactions/on_video/on_video_raise_hand_medium_dark.json",
  "on_video_raise_hand_medium_light": "./lottie/reactions/on_video/on_video_raise_hand_medium_light.json",
  "on_video_raise_hand_medium": "./lottie/reactions/on_video/on_video_raise_hand_medium.json",
  "on_video_raise_hand_yellow": "./lottie/reactions/on_video/on_video_raise_hand_yellow.json",
  "on_video_sad": "./lottie/reactions/on_video/on_video_sad.json",
  "on_video_slow_down": "./lottie/reactions/on_video/on_video_slow_down.json",
  "on_video_smile": "./lottie/reactions/on_video/on_video_smile.json",
  "on_video_speed_up": "./lottie/reactions/on_video/on_video_speed_up.json",
  "on_video_thumb_down_dark": "./lottie/reactions/on_video/on_video_thumb_down_dark.json",
  "on_video_thumb_down_light": "./lottie/reactions/on_video/on_video_thumb_down_light.json",
  "on_video_thumb_down_medium_dark": "./lottie/reactions/on_video/on_video_thumb_down_medium_dark.json",
  "on_video_thumb_down_medium_light": "./lottie/reactions/on_video/on_video_thumb_down_medium_light.json",
  "on_video_thumb_down_medium": "./lottie/reactions/on_video/on_video_thumb_down_medium.json",
  "on_video_thumb_down_yellow": "./lottie/reactions/on_video/on_video_thumb_down_yellow.json",
  "on_video_thumb_up_dark": "./lottie/reactions/on_video/on_video_thumb_up_dark.json",
  "on_video_thumb_up_light": "./lottie/reactions/on_video/on_video_thumb_up_light.json",
  "on_video_thumb_up_medium_dark": "./lottie/reactions/on_video/on_video_thumb_up_medium_dark.json",
  "on_video_thumb_up_medium_light": "./lottie/reactions/on_video/on_video_thumb_up_medium_light.json",
  "on_video_thumb_up_medium": "./lottie/reactions/on_video/on_video_thumb_up_medium.json",
  "on_video_thumb_up_yellow": "./lottie/reactions/on_video/on_video_thumb_up_yellow.json",
  "on_video_wow": "./lottie/reactions/on_video/on_video_wow.json",
  "prayer_dark": "./lottie/reactions/prayer_dark.json",
  "prayer_light": "./lottie/reactions/prayer_light.json",
  "prayer_medium_dark": "./lottie/reactions/prayer_medium_dark.json",
  "prayer_medium_light": "./lottie/reactions/prayer_medium_light.json",
  "prayer_medium": "./lottie/reactions/prayer_medium.json",
  "prayer_yellow": "./lottie/reactions/prayer_yellow.json",
  "raise_hand_dark": "./lottie/reactions/raise_hand_dark.json",
  "raise_hand_light": "./lottie/reactions/raise_hand_light.json",
  "raise_hand_medium_dark": "./lottie/reactions/raise_hand_medium_dark.json",
  "raise_hand_medium_light": "./lottie/reactions/raise_hand_medium_light.json",
  "raise_hand_medium": "./lottie/reactions/raise_hand_medium.json",
  "raise_hand_yellow": "./lottie/reactions/raise_hand_yellow.json",
  "sad": "./lottie/reactions/sad.json",
  "slow_down": "./lottie/reactions/slow_down.json",
  "smile": "./lottie/reactions/smile.json",
  "speed_up": "./lottie/reactions/speed_up.json",
  "thumb_down_dark": "./lottie/reactions/thumb_down_dark.json",
  "thumb_down_light": "./lottie/reactions/thumb_down_light.json",
  "thumb_down_medium_dark": "./lottie/reactions/thumb_down_medium_dark.json",
  "thumb_down_medium_light": "./lottie/reactions/thumb_down_medium_light.json",
  "thumb_down_medium": "./lottie/reactions/thumb_down_medium.json",
  "thumb_down_yellow": "./lottie/reactions/thumb_down_yellow.json",
  "thumb_up_dark": "./lottie/reactions/thumb_up_dark.json",
  "thumb_up_light": "./lottie/reactions/thumb_up_light.json",
  "thumb_up_medium_dark": "./lottie/reactions/thumb_up_medium_dark.json",
  "thumb_up_medium_light": "./lottie/reactions/thumb_up_medium_light.json",
  "thumb_up_medium": "./lottie/reactions/thumb_up_medium.json",
  "thumb_up_yellow": "./lottie/reactions/thumb_up_yellow.json",
  "wow": "./lottie/reactions/wow.json",
  "space": "./lottie/space.json",
  "success": "./lottie/success.json",
  "teams": "./lottie/teams.json",
  "webex_logo_loop": "./lottie/webex_logo_loop.json",
  "welcome": "./lottie/welcome.json"
}